module.exports = __webpack_public_path__ + "img/icn_miniprogram@3x.dbefd4b6.png";